module.exports = __webpack_public_path__ + "img/step7.dba5c97c.png";